// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.isFemale {\n  background-color: pink;\n}\n.isBIPOC {\n  background-color: burlywood;\n}\n.isBoth {\n  background-color: gold;\n}\n", ""]);
// Exports
module.exports = exports;
